import * as z from 'zod'
import {buildEntrySchemaFor} from '@github-ui/swp-core/schemas/contentful/entry'
import {RichTextSchema} from '@github-ui/swp-core/schemas/contentful/richText'

export const FootnoteSchema = buildEntrySchemaFor('footnote', {
  fields: z.lazy(() =>
    z.object({
      text: RichTextSchema,
    }),
  ),
})

export type Footnote = z.infer<typeof FootnoteSchema>
